import { appRoutes } from "../../routes/appRoutes";

const PATH_PREFIX_LABELS: Array<{ prefix: string; label: string; fallbackRoute: string }> = [
    { prefix: "/sites", label: "Sites", fallbackRoute: "/sites" },
    { prefix: "/customers", label: "Customers", fallbackRoute: "/customers" },
    { prefix: "/locations", label: "Locations", fallbackRoute: "/locations" },
    { prefix: "/hauliers", label: "Hauliers", fallbackRoute: "/hauliers" },
    { prefix: "/processors", label: "Processors", fallbackRoute: "/processors" },
    { prefix: "/tippers", label: "Tippers", fallbackRoute: "/tippers" },
    { prefix: "/vehicles", label: "Vehicles", fallbackRoute: "/vehicles" },
    { prefix: "/waste-received", label: "Waste Received", fallbackRoute: "/waste-received" },
    { prefix: "/waste-removed", label: "Waste Removed", fallbackRoute: "/waste-removed" },
    { prefix: "/waste-returns", label: "Waste Returns", fallbackRoute: "/waste-returns" },
    { prefix: "/ewc-codes", label: "EWC Codes", fallbackRoute: "/ewc-codes" },
    { prefix: "/disposal-recovery-codes", label: "Disposal/Recovery Codes", fallbackRoute: "/disposal-recovery-codes" },
    { prefix: "/physical-states", label: "Physical States", fallbackRoute: "/physical-states" },
    { prefix: "/pre-treatments", label: "Pre-Treatments", fallbackRoute: "/pre-treatments" },
    { prefix: "/source-activities", label: "Source Activities", fallbackRoute: "/source-activities" },
    { prefix: "/geographies", label: "Geographies", fallbackRoute: "/geographies" },
    { prefix: "/facility-operations", label: "Facility Operations", fallbackRoute: "/facility-operations" },
    { prefix: "/municipal-degradables", label: "Municipal/Degradable Flags", fallbackRoute: "/municipal-degradables" },
    { prefix: "/users", label: "Users", fallbackRoute: "/users" },
    { prefix: "/system-setup", label: "Admin Foundation", fallbackRoute: "/system-setup" },
    { prefix: "/admin", label: "Administration", fallbackRoute: "/admin" },
    { prefix: "/settings", label: "Settings", fallbackRoute: "/settings" },
    { prefix: appRoutes.wasteReturnTemplate, label: "EA Waste Return Template", fallbackRoute: appRoutes.wasteReturnTemplate },
];

export function resolveResourceLabel(pathname: string): string | undefined {
    const match = PATH_PREFIX_LABELS.find(
        (entry) => pathname === entry.prefix || pathname.startsWith(`${entry.prefix}/`)
    );
    return match?.label;
}

export function resolveFallbackRoute(pathname: string): string {
    const match = PATH_PREFIX_LABELS.find(
        (entry) => pathname === entry.prefix || pathname.startsWith(`${entry.prefix}/`)
    );
    return match?.fallbackRoute ?? "/dashboard";
}

/** True when pathname looks like an edit/detail route (has an id segment or /new). */
export function isDetailEditPathname(pathname: string): boolean {
    const segments = pathname.split("/").filter(Boolean);
    if (segments.length < 2) return false;
    const last = segments[segments.length - 1];
    if (last === "new") return true;
    // UUID-like or numeric id segment on a known entity path
    if (segments.length >= 2 && last !== "defaults" && !last.includes("?")) {
        const parent = `/${segments.slice(0, -1).join("/")}`;
        if (PATH_PREFIX_LABELS.some((e) => e.prefix === parent || parent.startsWith(`${e.prefix}/`))) {
            return true;
        }
    }
    return false;
}

export function isListPathname(pathname: string): boolean {
    const segments = pathname.split("/").filter(Boolean);
    if (segments.length === 1) return true;
    if (segments.length === 2 && segments[1] === "defaults") return false;
    return false;
}
